import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import EFPicture from '@elem/ui/ef-picture';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';

export default function TheComp() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('power_kits_48v_system');

    const items = [
        {
            img:
                locale === 'de'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1723517886742/20240813.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1721271693409/Service_02.png',
            title: t('S_card2_title'),
            desc: t('S_card2_desc'),
        },
        {
            img:
                locale === 'de'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1723687000217/de_Service_03.png'
                    : 'https://websiteoss.ecoflow.com/upload/image/1723687122253/us_Service_03.png',
            title: t('S_card3_title'),
            desc: t('S_card3_desc'),
        },
    ];

    if (locale === 'us') {
        items.unshift({
            img: 'https://websiteoss.ecoflow.com/upload/image/1721271684264/Service_01.png',
            title: t('S_card1_title'),
            desc: t('S_card1_desc'),
        });
    }

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-xx" />
            <EfTitle>{t('S_title')}</EfTitle>
            <ul className="items">
                {items?.map((item: any, k: number) => (
                    <li className="item" key={k}>
                        <div className="item-info">
                            <p className="item-title">{item.title}</p>
                            <p className="item-desc">{item.desc}</p>
                        </div>
                        <div className="item-img">
                            <EFPicture src={item.img} alt={item.title} />
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
